import { MODULE_NAME } from './constants';
import {
  useIsActive as useIsActiveByName,
  useSettings as useSettingsByName,
} from '../../hooks';

export const useIsActive = () => useIsActiveByName(MODULE_NAME);
export const useSettings = () => useSettingsByName(MODULE_NAME);
